import { env, systemEnv } from '#@/platform/lib/env/app'

export const APP_NAME = env.NEXT_PUBLIC_DISTRICT_APP_NAME

export const STAGE = env.NEXT_PUBLIC_DISTRICT_ENV

/**
 * Can be used to detect if the production environment is alpha STOP: DO NOT APPLY CUSTOM LOGIC TO ALPHA. This is for
 * internal use only.
 */
export const IS_ALPHA = env.NEXT_PUBLIC_DISTRICT_ENV_ALPHA

/** STOP: DO NOT APPLY CUSTOM LOGIC TO PREVIEW ENVIRONMENTS. This is for internal use only. */
export const IS_VERCEL_PREVIEW = systemEnv.VERCEL_ENV === 'preview'

/**
 * True on a deployed Vercel runtime (production or preview), where Vercel's edge manages the `x-vercel-*` request
 * headers. False in local dev and on non-Vercel runtimes, where those headers are just client input.
 */
export const IS_VERCEL_DEPLOYMENT = systemEnv.VERCEL_ENV !== 'development'
